import React from 'react';

function Marq() {
  const renderItem = (key) => (
    <div key={key} className="item">
      <h4 className="d-flex align-items-center">
        <span>Onde Ideias nascem e&nbsp;</span>
        <span className="main-color">marcas crescem.</span>
        <span className="icon-img-50 ml-30">
          <img src="/assets/imgs/isotipo-light.png" alt="" />
        </span>
      </h4>
    </div>
  );

  const renderBox = (prefix) => (
    <div className="box">
      {Array.from({ length: 3 }).map((_, i) => renderItem(`${prefix}-${i}`))}
    </div>
  );

  return (
    <section className="opacity-7">
      <div className="main-marq xlrg o-hidden">
        <div className="slide-har st1 strok">
          {renderBox('a')}
          {renderBox('b')}
        </div>
      </div>
      <div className="main-marq xlrg o-hidden">
        <div className="slide-har st2 non-strok">
          {renderBox('c')}
          {renderBox('d')}
        </div>
      </div>
    </section>
  );
}

export default Marq;
